import {Mapper} from '@s-ui/domain'

export default class FromMarketedMakesRawDataToMarketedMakesValueObjectMapper extends Mapper {
  constructor({mapper, valueObject}) {
    super()
    this._mapper = mapper
    this._valueObject = valueObject
  }

  setParams = params => {
    const {urlPrefix} = params
    this._urlPrefix = urlPrefix
    return this
  }

  map = ({makesList}) => {
    makesList = makesList.map(this._mapper.setParams({urlPrefix: this._urlPrefix}).map)
    return this._valueObject({makesList})
  }
}
